'use client';

import { useEffect, useRef, useState } from 'react';
import ChatSidebar from '@/components/inbox/chat-sidebar';
import ChatHeader from '@/components/inbox/chat-header';
import ChatInput from '@/components/inbox/chat-input';
import ChatBox from '@/components/inbox/chat-box';
import clsx from 'clsx';

type chatDataType = {
  id: string | number;
  text: string;
}[];

export default function InboxPage() {
  const [chat, setChat] = useState('');
  const [currentChat, setCurrentChat] = useState<{
    id: string | number;
    text: string;
  } | null>(null);

  const [data, setData] = useState<chatDataType>([]);
  const [toggler, setToggler] = useState(false);
  const [isLoading, setIsLoading] = useState(true); // Loading state
  const chatEndRef = useRef<HTMLDivElement | null>(null);
  // Fetch chat data on page load
  useEffect(() => {
    const fetchChats = async () => {
      const burl = `${process.env.NEXT_PUBLIC_API}`;

      let myid = null;

      try {
        if (typeof window !== 'undefined') {
          myid = sessionStorage.getItem('userId');
        }
      } catch (error) {
        console.error('sessionStorage is not available during build:', error);
      }

      try {
        console.log('Fetching chat list...'); // Debugging log
        const response = await fetch(`${burl}/getchatlistppl.php`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ myid }),
        });

        if (!response.ok) {
          throw new Error('Failed to fetch chat list.');
        }

        const result = await response.json();
        console.log('Fetched chat list:', result); // Debugging log

        if (result.records && Array.isArray(result.records)) {
          setData(result.records);
          if (result.records.length > 0) {
            setCurrentChat(result.records); // Set the first chat as active
            const recieve = result.records[0].UniqueID;
            try {
              console.log('Submitting chat message...'); // Debugging log
              const response = await fetch(`${burl}/getchatslist.php`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  myid,
                  message: chat,
                  receiveid: recieve,
                }),
              });

              if (!response.ok) {
                throw new Error('Failed to post chat message.');
              }

              const result = await response.json();
              console.log('Message submitted:', result); // Debugging log

              setData(result.records);
            } catch (error) {
              console.error('Error posting chat message:', error);
            }
          }
        } else {
          console.error('Invalid data structure:', result); // Log unexpected structure
        }
      } catch (error) {
        console.error('Error fetching chat list:', error);
      } finally {
        setIsLoading(false); // Set loading to false after fetching
      }
    };

    fetchChats();
    const interval = setInterval(fetchChats, 5000); // Polling every 5 seconds
    return () => clearInterval(interval);
  }, []);

  function handleCurrentChat(id: string) {
    setToggler(!toggler);
    const selectedChat = data.find((item) => item.id === id);
    if (selectedChat) {
      setCurrentChat(selectedChat);
    }
  }
  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [data]);
  async function handleSubmit(e: any) {
    e.preventDefault();
    if (chat.trim() === '' || !currentChat) return;

    const burl = `${process.env.NEXT_PUBLIC_API}`;

    let myid = null;

    try {
      if (typeof window !== 'undefined') {
        myid = sessionStorage.getItem('userId');
      }
    } catch (error) {
      console.error('sessionStorage is not available during build:', error);
    }
    // Replace with actual user ID logic
    const recipientId = currentChat[0].UniqueID; // Assuming `currentChat` holds recipient details

    const formData = new URLSearchParams();
    formData.append('sendorget', 'send');
    formData.append('uid', myid.toString());
    formData.append('gouid', recipientId);
    formData.append('msg', chat);

    try {
      const response = await fetch(`${burl}/chat.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString(),
      });

      if (!response.ok) {
        throw new Error('Failed to send message.');
      }

      const newMessage = { message: chat };

      // Adding the new message to the data array

      data.push(newMessage);
      const result = await response.json();
      console.log('Message sent:', result);

      setChat(''); // Clear input field after sending message

      // Fetch latest messages after sending
      fetchChats();
    } catch (error) {
      console.error('Error sending message:', error);
    }
  }

  return (
    <div className="container-fluid w-full py-8 md:py-12 xl:py-16">
      <div className=" relative mx-auto grid min-h-[500px] w-full !max-w-7xl grid-cols-1 gap-0 overflow-hidden rounded-xl md:min-h-[600px] md:grid-cols-[200px_auto] md:shadow-card xl:grid-cols-[250px_auto] 3xl:grid-cols-[300px_auto]">
        {!isLoading && Array.isArray(data) && data.length > 0 ? (
          <ChatSidebar
            className={clsx(
              'absolute inset-0 z-10 opacity-100 transition-all duration-500 md:static',
              toggler &&
                'translate-y-full opacity-50 md:translate-y-0 md:opacity-100',
            )}
            activeChatClassName="bg-white"
            currentChat={currentChat}
            onClick={(id) =>
              setCurrentChat(data.find((item) => item.id === id))
            }
          />
        ) : (
          <div className="flex items-center justify-center h-full">
            {isLoading ? (
              <span>Loading chats...</span>
            ) : (
              <span>No chats available.</span>
            )}
          </div>
        )}
        <div className="flex  flex-col pb-2 md:px-5 ">
          <ChatHeader
            currentChat={currentChat}
            onClick={() => setToggler(!toggler)}
          />
          <ChatBox chats={data} />
          <div ref={chatEndRef} />
          <ChatInput
            value={chat}
            onChange={(e) => setChat(e.target.value)}
            onSubmit={handleSubmit}
          />
        </div>
      </div>
    </div>
  );
}
